import type { ReactNode } from 'react';

/**
 * Carrusel horizontal reutilizable (estilo "Recommended for you" / "Trending").
 * Implementado con scroll-snap nativo + flechas de navegación opcionales.
 */
interface CarouselProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export const Carousel = ({ title, subtitle, children }: CarouselProps) => {
  return (
    <section className="space-y-3">
      <header className="flex items-end justify-between px-1">
        <div>
          <h2 className="text-display text-xl font-bold text-white">{title}</h2>
          {subtitle && <p className="text-sm text-slate-400">{subtitle}</p>}
        </div>
        <button className="text-xs font-semibold text-accent-400 hover:text-accent-500">
          Ver todo →
        </button>
      </header>
      <div className="relative">
        <div className="carousel-scroll flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2">
          {children}
        </div>
      </div>
    </section>
  );
};